import React, { useState } from "react";
import logo from "../../assets/app_logo.png";
import { translate } from "../../utils/translations/translate";
import Input from "../UI/Input";
import Button from "../UI/Button";
import { Link } from "react-router-dom";
import { StyledAuthSection, StyledForm, StyledForgotpassword, StyledLoginButton, StyledLogo } from "./styles";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
import { useAuth } from "./hooks/useAuth";
import isEmail from "validator/lib/isEmail";
import LoginIcon from '@mui/icons-material/Login';
const LoginForm = () => {
  const { loginUser, isError: errorMessage, isLoading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isEmailTouched, setIsEmailTouched] = useState(false);
  const [isPasswordTouched, setIsPasswordTouched] = useState(false);
  const isEmailEmpty = isEmailTouched && !email;
  const isValidEmail = isEmail(email);
  const isInvalidEmail = isEmailTouched && email && !isValidEmail;
  const isPasswordEmpty = isPasswordTouched && !password;
  const handleLoginFormSubmit = (e) => {
    e.preventDefault();
    setIsEmailTouched(true);
    setIsPasswordTouched(true);
    const inputEmail = email.trim();
    const inputPass = password.trim();
    if (!isValidEmail || !inputEmail || !inputPass) {
      return false;
    }
    loginUser(inputEmail, inputPass);
  };

  return (
    <StyledAuthSection className="tma_login_form_wrapper">
      <div className="tma_logo_container">
        <StyledLogo src={logo} alt="tma_app_logo" className="tma_app_logo" />
      </div>
      <div className="tma_login_content">
        <StyledForm
          onSubmit={handleLoginFormSubmit}
          noValidate
        >
          <h1 className="tma_form_title">{translate("labels.signIn")}</h1>
          <div
            className={`tma_form_control ${
              isEmailEmpty || isInvalidEmail ? "tma_form_error" : ""
            }`}
          >
            <Input
              id="tma_user_email"
              type="email"
              name="tma_user_email"
              placeholderLabelText={translate("labels.email")}
              labelText={""}
              showInfoToolTip={false}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              onBlur={() => {
                if (!isEmailTouched) {
                  setIsEmailTouched(true);
                }
              }}
            />
            {isEmailEmpty && (
              <p className="tma_error">{translate("labels.emailRequired")}</p>
            )}
            {isInvalidEmail && (
              <p className="tma_error">{translate("labels.invalidEmail")}</p>
            )}
          </div>
          <div
            className={`tma_form_control ${
              isPasswordEmpty ? "tma_form_error" : ""
            }`}
          >
            <Input
              autoComplete="new-password"
              id="tma_user_password"
              type="password"
              name="tma_user_password"
              placeholderLabelText={translate("labels.password")}
              labelText={""}
              showInfoToolTip={false}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              onBlur={() => {
                if (!isPasswordTouched) {
                  setIsPasswordTouched(true);
                }
              }}
            />
            {isPasswordEmpty && (
              <p className="tma_error">
                {translate("labels.passwordRequired")}
              </p>
            )}
            <StyledForgotpassword>
              <p>
                <Link to={SITE_LINKS_SCHEMA.FORGOT_PASS}>
                  {translate("labels.forgotPassword")}?
                </Link>
              </p>
            </StyledForgotpassword>
          </div>
          
          <div className="tma_form-feedback">
            {errorMessage && <p className="tma_error">{errorMessage}</p>}
          </div>
          <div className="tma_form_info_links">
            <a href={process.env.REACT_APP_HELP_PAGE_LINK} target="_blank" rel="noreferrer">
              <span className="tma_link_label">{translate("labels.haveAQuestion")}</span>
              <span className="tma_link_item">{translate("labels.reachOut")}</span>
            </a>
            <a href={process.env.REACT_APP_ABOUT_PAGE_LINK} target="_blank" rel="noreferrer">
              <span className="tma_link_label">{translate("labels.learnMore")}</span>
              <span  className="tma_link_item">{translate("labels.aboutUs")}</span>
            </a>
          </div>
          <StyledLoginButton>
            <Button
              iconcomponent={!isLoading && LoginIcon}
              isLoading={isLoading}
              text={translate("labels.signIn")}
              type="submit"
            />
          </StyledLoginButton>
        </StyledForm>
      </div>
    </StyledAuthSection>
  );
};

export { LoginForm };
